import { Link } from "react-router-dom";
import { useApp } from "../app/AppContext.jsx";

export default function Footer() {
  const { t } = useApp();
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div>
          <div className="topbar__logo" style={{ fontSize: 16 }}>APEX<span>CARS</span></div>
          <p className="small muted" style={{ marginTop: 8 }}>{t("footer.tagline")}</p>
        </div>

        <nav style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Link to="/stock">{t("nav.stock")}</Link>
          <Link to="/auctions">{t("nav.auctions")}</Link>
          <Link to="/import-calculator">{t("nav.calculator")}</Link>
          <Link to="/how-it-works">{t("nav.how")}</Link>
        </nav>

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <a href="mailto:contact@apexcars.ch">contact@apexcars.ch</a>
          <span>Avenue de la Gare 5 · 1950 Sion</span>
          <a href="https://instagram.com/apexcars.ch" target="_blank" rel="noopener noreferrer">Instagram</a>
        </div>

        <p className="tiny muted" style={{ maxWidth: 420, lineHeight: 1.7 }}>
          {t("footer.disclaimer")}
        </p>
      </div>
      <p className="tiny muted" style={{ maxWidth: 1400, margin: "26px auto 0" }}>
        © {new Date().getFullYear()} ApexCars. {t("footer.rights")}
      </p>
    </footer>
  );
}
